import React from "react";
import { formatNumber } from "../../../functions/formatNumber";

const RecapScontrino = ({ fatturato, contributi, imposteTotali, netto }) => {
  return (
    <div
      style={{ border: "1px solid orange" }}
      className="p-4 h-fit rounded-md dark:bg-gray-500"
    >
      <Item label={"Fatturato"} value={`${formatNumber(fatturato)} €`} />
      <Item label={"Contributi"} value={`${formatNumber(contributi)} €`} />
      <Item label={"Imposta"} value={`${formatNumber(imposteTotali)} €`} />
      <Item label={"Netto"} value={`${formatNumber(netto)} €`} />
    </div>
  );
};

export default RecapScontrino;

const Item = ({ label, value }) => {
  return (
    <div className="flex flex-row gap-2 justify-between">
      <span>{label}</span>
      <span className="text-black font-bold dark:text-orange-400">{` ${value}`}</span>
    </div>
  );
};
